"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Klasa analizująca DOM modala 'added to cart'
 */
var CartModalAnalyze = /** @class */ (function () {
    function CartModalAnalyze(container) {
        this.container = container;
    }
    /**
     * Pobierz tablicę SKU, dla których został wygenerowane wyniki cross sellingu
     * @return {string[]}
     */
    CartModalAnalyze.prototype.getCrossSellingSKUs = function () {
        var zone = this.container.querySelector('#crossSellZone');
        var skus = [];
        if (zone instanceof Element) {
            var skuSet = zone.getAttribute('data-cross-selling');
            if (skuSet !== null) {
                skuSet.split(',').forEach(function (sku) {
                    skus.push(sku.trim());
                });
            }
        }
        return skus;
    };
    return CartModalAnalyze;
}());
exports.default = CartModalAnalyze;
